'use strict';

const Analytics = require('./analytics');

class AnalyticsAccount extends Analytics {
    init (globalContainer, helperContainer) {
        var _self = this;
        this.logName = 'AnalyticsAccount';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();
        this.prepareObserversRegistration();
        this.prepareErrorObservers();

        if (this.helper.checkPage('registrationcomplete')) {
            if ($('#loyaltyRegistration').length > 0) {
                this.pushRegisterConfirmInteractionLoyalty();
            } else if ($('#socialRegistration').length > 0) {
                this.pushRegisterConfirmInteractionSocial();
            } else {
                this.pushRegisterConfirmInteraction();
            }
        } else {
            if ($('.notFoundPage').length === 0) {
                window.sessionStorage.removeItem('reloadState');
            }
        }

        if (this.helper.checkPage('newregistration')) {
            if ($('#loyaltyRegistration').length > 0 || localStorage.getItem('firingRegistrationStep6Loyalty') === 'true') {
                this.pushRegisterConfirmInteractionDoubleOptinLoyalty();
            } else if ($('#socialRegistration').length > 0) {
                this.pushRegisterConfirmInteractionDoubleOptinSocial();
            } else {
                this.pushRegisterConfirmInteractionDoubleOptin('success');
            }
        } else {
            window.sessionStorage.removeItem('reloadStateDoubleOptin');
        }

        this.prepareAccountObservers();
        this.prepareObserversSocialRegistration();
        this.prepareSavingCardObservers();
        this.prepareAccountNavigationObservers();
        this.prepareSaveToWalletObservers();
        this.prepareProfileEnrichObservers();
    }

    pushRegisterConfirmInteraction (result) {
        if (window.sessionStorage.getItem('reloadState')) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep4') === 'true') {
            localStorage.setItem('firingRegistrationStep4', '');
        } else {
            return;
        }

        let location = localStorage.getItem('locationRegistration');
        localStorage.setItem('locationRegistration', '');

        const typeOfAccount = this.helper.getTypeOfAccount();
        this.quickImpressionSender.pushRegisterConfirmInteraction(location, result, typeOfAccount);
        window.sessionStorage.setItem('reloadState', true);
    }

    pushRegisterConfirmInteractionLoyalty () {
        if (window.sessionStorage.getItem('reloadState')) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep5Loyalty') === 'true') {
            localStorage.setItem('firingRegistrationStep6Loyalty', 'true');
            localStorage.setItem('firingRegistrationStep5Loyalty', '');
        } else {
            return;
        }
        let location = localStorage.getItem('locationRegistration');
        localStorage.setItem('locationRegistration', '');

        this.quickImpressionSender.pushRegisterInteractionLoyaltyStep5(location, 'success');
        window.sessionStorage.setItem('reloadState', true);
    }

    pushRegisterConfirmInteractionSocial () {
        if (window.sessionStorage.getItem('reloadState')) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep4Social') === 'true') {
            localStorage.setItem('firingRegistrationStep5Social', 'true');
            localStorage.setItem('firingRegistrationStep4Social', '');
        } else {
            return;
        }
        let socialName = '';
        if ($('#socialRegistration').length) {
            socialName = $('#socialRegistration').data('social-name');
        }

        this.quickImpressionSender.pushSocialRegistrationThankYouInteraction(socialName);
        window.sessionStorage.setItem('reloadState', true);
    }

    pushRegisterConfirmInteractionDoubleOptin (result) {
        if (window.sessionStorage.getItem('reloadStateDoubleOptin')) {
            return;
        }

        this.quickImpressionSender.pushRegisterConfirmInteractionDoubleOptin(result);
        window.sessionStorage.setItem('reloadStateDoubleOptin', true);
    }

    pushRegisterConfirmInteractionDoubleOptinLoyalty () {
        if (window.sessionStorage.getItem('reloadStateDoubleOptin')) {
            return;
        }
        if ($('.analytics-registration-confirm').length === 0) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep6Loyalty') === 'true') {
            localStorage.setItem('firingRegistrationStep6Loyalty', '');
        } else {
            return;
        }

        this.quickImpressionSender.pushRegisterInteractionLoyaltyStep6('success');
        window.sessionStorage.setItem('reloadStateDoubleOptin', true);
    }

    pushRegisterConfirmInteractionDoubleOptinSocial () {
        if (window.sessionStorage.getItem('reloadStateDoubleOptin')) {
            return;
        }
        if ($('.analytics-registration-confirm').length === 0) {
            return;
        }
        if (localStorage.getItem('firingRegistrationStep5Social') === 'true') {
            localStorage.setItem('firingRegistrationStep5Social', '');
        } else {
            return;
        }
        let socialName = '';
        if ($('#socialRegistration').length) {
            socialName = $('#socialRegistration').data('social-name');
        }

        this.quickImpressionSender.pushSocialRegistrationConfirmInteraction(socialName);
        window.sessionStorage.setItem('reloadStateDoubleOptin', true);
    }

    prepareObservers () {
        var _self = this;
        let location;

        if (this.helper.checkPage('checkout')) {
            location = 'checkout_form';
        } else if (this.helper.checkPage('login')) {
            location = 'subscription_form';
        } else if (this.helper.checkPage('wishlist')) {
            location = 'wishlist';
        } else if (this.helper.checkPage('confirmation') || this.helper.checkPage('registrationcomplete')) {
            location = 'thank_you_page';
        } else if (this.helper.checkPage('myprofile')) {
            location = 'my_account';
        } else if (this.helper.checkPage('accountnewregistration')) {
            location = 'registration';
        } else if (this.helper.checkPage('cart')) {
            location = 'cart';
        } else {
            location = 'header';
        }

        $('body').on('customer:login', function (e, data) {
            let anyErrors = false;
            let rememberMe = data.rememberMe;
            let sessionExpired = data.sessionExpired;
            if (data.data) {
                if (data.data.error) {
                    anyErrors = true;
                }
                if (data.data.rememberMe) {
                    rememberMe = data.data.rememberMe;
                }
                if (data.data.sessionExpired) {
                    sessionExpired = data.data.sessionExpired;
                }
            }

            _self.quickImpressionSender.pushLoginInteraction(data.type, data.socialName || '', rememberMe, sessionExpired, location, anyErrors);
        });

        // Registration - Step 1: email
        $('body').on('customer:registerFirst', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            if (_self.helper.checkPage('welcome')) {
                let path = window.location.pathname.split('/');
                location = path[path.length - 2];
            }
            // Check if user registers with card
            let loyaltyMethod = localStorage.getItem('registrationMethod');
            if (loyaltyMethod && loyaltyMethod === 'loyalty_card') {
                _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep2('', anyErrors);
                return;
            }
            localStorage.setItem('registrationMethod', 'registration');
            localStorage.setItem('locationRegistration', location);
            _self.quickImpressionSender.pushRegisterInteraction(data.type, location, anyErrors);
        });

        // Registration - Loyalty - Step 1
        $('body').on('customer:registrationLoyaltyCardStep', function (e, data) {
            localStorage.setItem('registrationMethod', 'loyalty_card');
            _self.quickImpressionSender.pushRegisterInteractionLoyalty(
                data.flow,
                data.data && data.data.error
            );
        });

        $('body').on('analytics:prepareLoyaltySubscription', function (e) {
            if (location === 'thank_you_page') {
                _self.quickImpressionSender.pushRegisterLoyalty(_self.helperData.userId, 'thank you');
            } else {
                _self.quickImpressionSender.pushRegisterLoyalty(_self.helperData.userId, 'my reviews');
            }
        });

        $('body').on('analytics:proceedToLoyaltyModal', function (e) {
            _self.quickImpressionSender.pushRegisterLoyalty(_self.helperData.userId, 'loyalty_modal');
        });

        // Social Login / Registration
        $('body').on('customer:socialLogin', function (e, data) {
            let anyErrors = false;
            if (data && data.error && data.error.length) {
                anyErrors = true;
            }
            _self.quickImpressionSender.pushLoginInteraction(data.type, data.socialName || '', data.rememberMe, data.sessionExpired, location, anyErrors);
        });

        // Persistent Login / tooltip
        $('body').on('customer:persistentTooltip', function (e, data) {
            _self.quickImpressionSender.pushPersistentLoginTooltipInteraction();
        });

        $('body').on('customer:ratingAndReviewsTabsAction', function (e, topic) {
            _self.quickImpressionSender.pushRatingAndReviewsTabsInteraction(_self.helper.formatNameForAnalytics(topic));
        });

        $('body').on('customer:newsletterPreferencesSave', function (e, data) {
            var brandCodes = _self.helper.getFormatedNewsletterPreferenceBrands(data.brands);
            _self.quickImpressionSender.pushNewsletterPreferenceSave(
                data.direktMarketingAgreement,
                data.profilingAgreement,
                brandCodes
            );
        });

        $('body').on('analytics:accountRemoveConfirmation', function (e) {
            _self.quickImpressionSender.pushMyAccountRemoveConfirmation();
        });

        $('body').on('analytics:registerConfirmOptin', function (e, data) {
            let method = localStorage.getItem('registrationMethod');

            if (method === 'loyalty_card') {
                _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep6(data.error ? 'error' : 'success');
                return;
            }

            _self.quickImpressionSender.pushRegisterConfirmInteractionDoubleOptin(data.error ? 'error' : 'success');
        });
    }

    prepareAccountObservers () {
        var _self = this;

        $('.analytics-editBillingAddress').on('click', function () {
            localStorage.setItem('lastAction', 'add_billing_address');
            _self.quickImpressionSender.pushUpdateAddress('change');
        });

        $('.js-accountPage-editAddress').on('click', function () {
            localStorage.setItem('lastAction', 'change');
            _self.quickImpressionSender.pushUpdateAddress('change');
        });

        $('body').on('click', '.js-add-address', function () {
            localStorage.setItem('lastAction', 'new_address');
            _self.quickImpressionSender.pushUpdateAddress('new_address');
        });

        $('body').on('address:submit', function (e) {
            let lastAction = localStorage.getItem('lastAction');
            _self.quickImpressionSender.pushUpdateAddress(lastAction);
        });

        $('body').on('address:remove', function (e) {
            _self.quickImpressionSender.pushUpdateAddress('remove_address_confirmation');
        });

        $('body').on('click', '.analytics-unsubscribe-loyalty', function (e) {
            _self.quickImpressionSender.pushLoyaltyUnsubscribeInteraction();
        });
    }

    prepareObserversRegistration () {
        var _self = this;
        let mode = this.helper.checkPage('loyalty') ? 'only_loyalty' : 'profile_loyalty';

        // Registration - Step 2: telephone
        $('body').on('customer:registerSecond', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            if ($('.page').data('action') === 'Account-Loyalty' && anyErrors) {
                return;
            }

            let registrationMethod = localStorage.getItem('registrationMethod');
            if (registrationMethod && registrationMethod === 'loyalty_card') {
                _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep3('', anyErrors);
                return;
            }
            _self.quickImpressionSender.pushRegisterInteractionTelephone(anyErrors);
        });

        // Registration - Loyalty - Step 2
        $('body').on('customer:registrationLoyaltyStep2', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep2('', anyErrors);
        });

        // Registration - Loyalty - Step 3
        $('body').on('customer:registrationLoyaltyStep3', function (e, data) {
            let anyErrors = false;
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep3('', anyErrors);
        });

        // Registration - Step 4 (old 3): Personal Data
        $('body').on('customer:registrationLoyaltyStep4', function (e, data) {
            let anyErrors = false;
            let location = localStorage.getItem('locationRegistration');
            if (data.data && data.data.error) {
                anyErrors = true;
            }
            if (!anyErrors) {
                localStorage.setItem('firingRegistrationStep5Loyalty', 'true');
            }
            _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep4(anyErrors, location, data.rememberMe);
        });

        // Registration - Step 3: Personal Data
        $('body').on('customer:registerThird', function (e, data) {
            let anyErrors = false;
            var analyticsMode = _self.helper.getTypeOfAccount();

            if ((data.data && data.data.error) || data.status === 'error') {
                anyErrors = true;
            }

            if ($('#loyaltyCheck').is(':checked') && !anyErrors) {
                analyticsMode = 'profile_loyalty';
                $('body').trigger('customer:registerLoyalty', 'profile_loyalty');
            }

            let location = localStorage.getItem('locationRegistration');
            let method = localStorage.getItem('registrationMethod');

            if (!anyErrors) {
                localStorage.setItem('firingRegistrationStep4', 'true');

                method === 'loyalty_card'
                    ? _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep5(location, 'success')
                    : _self.quickImpressionSender.pushRegisterConfirmInteraction(location, 'success');
            }

            if (method === 'loyalty_card') {
                _self.quickImpressionSender.pushRegisterInteractionLoyaltyStep4(anyErrors, location, data.rememberMe);
                return;
            }

            _self.quickImpressionSender.pushRegisterInteractionPersonalData(analyticsMode, anyErrors, location, data.rememberMe);
        });

        // Registration - Loyalty
        $('body').on('customer:registerLoyalty', function (e, analyticsMode) {
            _self.quickImpressionSender.pushRegisterInteractionLoyaltyRegistration(analyticsMode);
        });
    }

    prepareObserversSocialRegistration () {
        var _self = this;

        $('body').on('click', '.socialLoginContainer button', function (e) {
            let socialName = _self.helper.formatString($(e.currentTarget).attr('title'));
            _self.quickImpressionSender.pushSocialRegistrationInteraction(socialName || '');
        });

        $('body').on('customer:socialRegistration', function (e, data) {
            _self.quickImpressionSender.pushSocialRegistrationInteraction(data.socialName || '');
        });

        $('body').on('customer:registerSocialFirst', function (e, data) {
            let anyErrors = false;
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            if (!anyErrors) {
                localStorage.setItem('socialFirstStepMail', 'true');
            }
            _self.quickImpressionSender.pushSocialRegistrationStep1Interaction('email', socialName, anyErrors);
        });

        $('body').on('customer:registerSocialSecond', function (e, data) {
            let anyErrors = false;
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            let socialFirstStepMail = localStorage.getItem('socialFirstStepMail');
            if (!socialFirstStepMail || socialFirstStepMail == '') {
                _self.quickImpressionSender.pushSocialRegistrationStep1Interaction('phone', socialName, anyErrors);
            } else {
                _self.quickImpressionSender.pushSocialRegistrationStep2Interaction('phone', socialName, anyErrors);
            }
        });

        $('body').on('customer:registerSocialThird', function (e, data) {
            let anyErrors = false;
            let analyticsMode = 'only_social_registration';
            if (data && data.data && data.data.error && data.data.error.length) {
                anyErrors = true;
            }
            let socialName = '';
            if ($('#socialRegistration').length) {
                socialName = $('#socialRegistration').data('social-name');
            }
            if ($('.loyalty-flag:checked').length === 1 && !anyErrors) {
                analyticsMode = 'social_profile_loyalty';
                $('body').trigger('customer:registerLoyalty', 'profile_loyalty');
            }
            if (!anyErrors) {
                localStorage.setItem('firingRegistrationStep4Social', 'true');
            }
            _self.quickImpressionSender.pushSocialRegistrationStep3Interaction(analyticsMode, socialName, anyErrors, data.rememberMe);
        });
    }

    prepareErrorObservers () {
        var _self = this;

        $('body').on('customer:account_error', function (e, data) {
            let socialFirstStepMail = localStorage.getItem('socialFirstStepMail');
            if (data && data.type && data.type.indexOf('social') !== -1) {
                if (data.step == 'step2_phone' && (!socialFirstStepMail || socialFirstStepMail == '')) {
                    data.step = 'step1_phone';
                }
            }
            if ($('.page').data('action') !== 'Account-Loyalty') {
                _self.quickImpressionSender.pushLoginOrRegistrationError(data.type, data.step, data.errorMsg);
            }
        });

        $('body').on('customer:social_email_already_used', function (e, data) {
            _self.quickImpressionSender.pushSocialRegistrationStep1Interaction(data.type, data.socialName, data.errorMsg);
        });
    }

    prepareSavingCardObservers () {
        var _self = this;

        $('body').on('click', '.analytics-add-new-cc', function () {
            _self.quickImpressionSender.pushAddCreditCard('my_account');
        });

        $('body').on('account:savingCard', function () {
            _self.quickImpressionSender.pushSaveCreditCard('my_account');
        });

        $('body').on('click', '.js-accountPage-ccSavedCardsSection-ccSavedCard-editPayment', function () {
            _self.quickImpressionSender.pushUpdateCreditCard('change_credit_card');
        });

        $('body').on('account:removingCard', function (e, { action }) {
            _self.quickImpressionSender.pushUpdateCreditCard(action);
        });

        $('body').on('checkout:addCreditCard', function () {
            _self.quickImpressionSender.pushAddCreditCard('checkout');
        });

        $('body').on('click', '.custom-form-add-new-cc .submit-payment', function () {
            if ($('#saveCreditCard').is(':checked:visible')) {
                _self.quickImpressionSender.pushSaveCreditCard('checkout');
            }
        });
    }

    prepareAccountNavigationObservers () {
        var _self = this;

        $('.analytics-menu-items').on('click', function (e) {
            let voice = ($(this).data('analytic-name'));
            _self.quickImpressionSender.pushNavigationRelatedToMyAccount(_self.helper.formatString(voice));
        });

        $('.account-menu-link').on('click', function (e) {
            let voice = ($(this).data('analytic-name'));
            _self.quickImpressionSender.pushNavigationRelatedToMyAccount(_self.helper.formatString(voice));
        });
    }

    prepareSaveToWalletObservers () {
        var _self = this;

        $('body').on('analytics:saveGoogleWalletCard', function (e, data) {
            _self.quickImpressionSender.pushSaveToWallet('google_pay');
        });
        $('body').on('analytics:saveAppleWalletCard', function (e, data) {
            _self.quickImpressionSender.pushSaveToWallet('apple');
        });
    }

    prepareProfileEnrichObservers () {
        var _self = this;

        function getTopic (step) {
            let stepMap = {
                'step_1': 'favourite_collection',
                'step_2': 'favourite_product_categories',
                'step_3': 'kind_of_fabrics',
                'step_4': 'buy_for-occasions_to_wear-hobbies'
            };
            let topic = stepMap[step];
            if (topic) {
                return topic;
            }
            return 'other';
        }
        $('body').on('click', '.analytics-enrich-btn', function () {
            _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnly();
        });

        $('body').on('analytics:profileEnrich', function (e, data) {
            let step = data.step;
            let preferences = data.preferences;
            var descriptionPreferences = [];
            if (step !== 'step_2') {
                let amountOfPreferences = preferences.length;
                preferences = preferences.join('+').toLowerCase();

                for (let i = 0; i < amountOfPreferences; i++) {
                    let tempPreferences = [];
                    let tempPreferences4Letters = [];
                    tempPreferences.push(preferences.split('+'));
                    tempPreferences[0][i] = tempPreferences[0][i].replace('-', '_');

                    if ((/\s/).test(tempPreferences[0][i])) {
                        var checkForSpaces = tempPreferences[0][i].replace(/ /g, '_');
                        checkForSpaces = checkForSpaces.split('_');

                        for (let j = 0; j < checkForSpaces.length; j++) {
                            tempPreferences4Letters.push(checkForSpaces[j].slice(0, 4));
                        }
                        tempPreferences4Letters = tempPreferences4Letters.join(' ');
                        tempPreferences4Letters = tempPreferences4Letters.replace(/ /g, '_');
                    } else {
                        tempPreferences4Letters = tempPreferences[0][i].slice(0, 4);
                    }

                    descriptionPreferences.push(tempPreferences4Letters);
                }
                descriptionPreferences = descriptionPreferences.join('-');
                descriptionPreferences = descriptionPreferences.replace(/ /g, '_');
            }
            let category = data.categories;
            let subcategory = data.subcategories;
            switch (step) {
            case 'step_1':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep01((getTopic(step)), descriptionPreferences);
                break;
            case 'step_2':
                category = category.join('_');
                let subcategory4Letters = [];
                let amountOfSubcategory = subcategory.length;
                subcategory = subcategory.join('-').toLowerCase();

                for (let i = 0; i < amountOfSubcategory; i++) {
                    let tempSubcategory = [];
                    let tempSubcategory4Letters = [];
                    tempSubcategory.push(subcategory.split('-'));

                    if ((/\s/).test(tempSubcategory[0][i])) {
                        var checkForSpacesSubcategory = tempSubcategory[0][i].replace(/ /g, '_');
                        checkForSpacesSubcategory = checkForSpacesSubcategory.split('_');

                        for (let j = 0; j < checkForSpacesSubcategory.length; j++) {
                            tempSubcategory4Letters.push(checkForSpacesSubcategory[j].slice(0, 4));
                        }
                        tempSubcategory4Letters = tempSubcategory4Letters.join('_');
                    } else {
                        tempSubcategory4Letters = tempSubcategory[0][i].slice(0, 4);
                    }

                    subcategory4Letters.push(tempSubcategory4Letters);
                }

                subcategory4Letters = subcategory4Letters.join('-');
                subcategory4Letters = subcategory4Letters.replace(/ /g, '_');
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep02(category, subcategory4Letters);
                break;
            case 'step_3':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep03((getTopic(step)), descriptionPreferences);
                break;
            case 'step_4':
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyStep04((getTopic(step)), descriptionPreferences);
                _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyFinished();
                break;
            }
        });

        $('body').on('click', '.analytics-proceed-exit', function (e, data) {
            var $mappingContainer = $('.mapping-container');
            var currentStep = $mappingContainer.attr('data-step');

            _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyLeavingSurvey(getTopic(currentStep));
        });
        $('body').on('click', '.analytics-enrich-edit', function (e, data) {
            let currentStep = $(e.currentTarget).data('analyticslabel');

            _self.quickImpressionSender.pushProfileEnrichmentLoyaltyOnlyEditingPreferences(getTopic(currentStep));
        });
    }
}

const obj = new AnalyticsAccount();
module.exports = obj;
